import Upgrade from './Upgrade';

export default Upgrade;
